import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GuestListItem from "../guestList/GuestList";
import RefundList from "../refundList/RefundList";
import OtherPurchaseOptions from "../otherPurchaseOptions/OtherPurchaseOptions";
import "./DetailedEvent.css";
import { AuthContext } from "../../context/auth";
import DeclineModal from "../../Modals/declineModal/DeclineModal";
import ShareLinkModal from "../../Modals/shareLinkModal/ShareLinkModal";
import PurchaseOptionsModal from "../../Modals/purchaseOptionsModal/PurchaseOptionsModal";
import HostProfile from "../hostProfile/HostProfile";
import "../hostProfile/HostProfile.css";
import MandatoryPurchaseModal from "../../Modals/mandatoryPurchaseModal/MandatoryPurchaseModal";
import QRScanner from "../qrScanner/QRScanner";
import CheckInConfirmationModal from "../../Modals/checkInConfirmationModal/CheckInConfirmationModal";
import DigitalTicket from "../../pages/digitalTicket/DigitalTicket";
import axios from "axios";
import InviteTypeSelectorModal from "../../Modals/invieTypeSelector/InviteTypeSelectorModal";
import UsherList from "../usherList/UsherList";
import extractColorOfTheDay from "../../helper/extractColorOfTheDay";
import GiftComponent from "../giftComponent/GiftComponent";
import EventStatusModal from "../../Modals/eventStatusModal/EventStatusModal";
import ContactInfoModal from "../../Modals/contactinfomodal/ContactInfoModal";
import AcceptModal from "../../Modals/acceptModal/AcceptModal";
import InterestedSuccessModal from "../../Modals/interestedSuccessModal/InterestedSuccessModal";
import { initializePaidEventSession } from "../../helper/paidEventSignupSession";
import RoleSwitchConfirmationModal from "../../Modals/roleSwitchConfirmationModal/RoleSwitchConfirmationModal";

import { generateHtmlReport } from "./generatePdfReport";
import { eventDetailsDownloadCSV } from "./eventDetailsDownloadCSV";
import {
  formatCurrency,
  formatDateWithOrdinal,
  formatDate,
  getEventStatus,
} from "../../helper/formatCurrency";

import { storeFilteredEvent } from "../../helper/storeFIlteredEvent";

import useUshers from "../../helper/useUshers";

const DetailedEvent = ({
  event,
  guests,
  ushers,
  refunds,
  setRefunds,
  others,
  withSearch = false,
  userRole,
  isAuthenticated = false,
  isUsher = false,
  isHost = false,
  isGuest = false,
  isUnauthenticatedUser = false,
  onRefresh,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, setUser } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("about");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [mandatoryPurchaseData, setMandatoryPurchaseData] = useState(null);
  const [openMandatoryModal, setOpenMandatoryModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [scannerVisible, setScannerVisible] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);
  const [scannedGuestData, setScannedGuestData] = useState(null);
  const [isCheckingIn, setIsCheckingIn] = useState(false);
  const [showDigitalTicket, setShowDigitalTicket] = useState(false);
  const [usherApprovalStatus, setUsherApprovalStatus] = useState(null);
  const [enrichedGuests, setEnrichedGuests] = useState([]);
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [inviteSelectorVisible, setInviteSelectorVisible] = useState(false);
  const [inviteRole, setInviteRole] = useState("guest");

  const [eventStatusModalVisible, setEventStatusModalVisible] = useState(false);
  const [eventStatusModalType, setEventStatusModalType] = useState(null);
  const [purchaseType, setPurchaseType] = useState(null);
  const [purchaseOptions, setPurchaseOptions] = useState([]);
  const [isMandatoryPurchaseModalOpen, setIsMandatoryPurchaseModalOpen] =
    useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [isProceeding, setIsProceeding] = useState(false);

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [hasShownInterest, setHasShownInterest] = useState(false);
  const [isSubmittingInterest, setIsSubmittingInterest] = useState(false);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState({
    title: "",
    message: "",
  });

  const [showRoleSwitchModal, setShowRoleSwitchModal] = useState(false);
  const [originalRoleBeforeSwitch, setOriginalRoleBeforeSwitch] =
    useState(null);
  const [isRoleSwitching, setIsRoleSwitching] = useState(false);

  const [showDownloadOptions, setShowDownloadOptions] = useState(false);

  const getInitialScheduleIndex = () => {
    if (event?.dateOption !== "multiple" || !event?.multipleDates?.length)
      return 0;

    const now = new Date();

    const getEntryDateTime = (entry) => {
      const dateStr = entry.date?.$date || entry.date || "";
      const entryDate = new Date(dateStr);
      if (!entry.time) return entryDate;

      const timeMatch = entry.time.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (timeMatch) {
        let hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        const meridiem = timeMatch[3].toUpperCase();
        if (meridiem === "AM" && hours === 12) hours = 0;
        if (meridiem === "PM" && hours !== 12) hours += 12;
        return new Date(
          Date.UTC(
            entryDate.getUTCFullYear(),
            entryDate.getUTCMonth(),
            entryDate.getUTCDate(),
            hours,
            minutes,
            0
          )
        );
      }
      return entryDate;
    };

    const nextIdx = event.multipleDates.findIndex((entry) => {
      const entryDateTime = getEntryDateTime(entry);
      return entryDateTime >= now;
    });

    if (nextIdx >= 0) return nextIdx;
    return event.multipleDates.length - 1;
  };

  const [selectedScheduleIndex, setSelectedScheduleIndex] = useState(() =>
    getInitialScheduleIndex()
  );

  const eventId = event?._id || null;

  const { ushers: usherStats } = useUshers(eventId);

  const guestId = user?._id || null;

  const effectiveIsUnauthenticated =
    isUnauthenticatedUser || (!isHost && !isGuest && !isUsher);

  const isUsherApproved = usherApprovalStatus === "confirmed";
  const isUsherRejected = usherApprovalStatus === "rejected";
  const isUsherPending = usherApprovalStatus === "pending";
  const isUsherJoinedEvent = isUsher && usherApprovalStatus !== null;

  const invitation = event?.invitations?.find((invitation) => {
    return invitation.guestId && invitation.guestId._id === guestId;
  });

  const eventStatus = invitation ? invitation.status : null;

  const isPaidEvent = (event) => {
    if (!event) return false;

    const hasTickets =
      event.isEntryFeeApplicable && event.ticketFee?.length > 0;

    const hasEventAttire =
      event.isEventAttireCompulsory &&
      event.isEventAttireAvailable &&
      event.eventAttire?.asoEbiImages?.length > 0;

    // const hasCashGift = event.isCashGiftAccepted;

    return hasTickets || hasEventAttire;
  };

  const isPublicEventNotOwnedByUser = () => {
    if (!event) return false;

    const eventUserId = event.userId;

    const isPublic = event.visibility === "public";
    const isNotOwner = eventUserId !== user?._id;

    return isPublic && isNotOwner;
  };

  const shouldShowInterestedForAuthUser = () => {
    if (!isAuthenticated) return false;
    if (!isPublicEventNotOwnedByUser()) return false;
    if (invitation) return false;

    if (isUsherJoinedEvent) return false;

    return true;
  };

  const downloadBtnRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, right: 0 });

  const downloadReport = () => {
    if (!showDownloadOptions && downloadBtnRef.current) {
      const rect = downloadBtnRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + window.scrollY + 4,
        right: window.innerWidth - rect.right,
      });
    }
    setShowDownloadOptions(!showDownloadOptions);
  };

  const hasAlreadyExpressedInterest = () => {
    if (!event?.invitations || !user?._id) return false;

    const userInvitation = event.invitations.find(
      (inv) => inv.guestId?._id === user._id
    );

    return userInvitation?.status === "accepted";
  };

  useEffect(() => {
    storeFilteredEvent(event, user._id);
  }, [user._id]);

  useEffect(() => {
    if (isGuest && eventStatus === "declined" && activeTab === "others") {
      setActiveTab("about");
    }
  }, [eventStatus, isGuest, activeTab]);

  useEffect(() => {
    if (openMandatoryModal) {
      setIsPurchaseModalOpen(false);
      setMandatoryPurchaseData(openMandatoryModal);
    }
  }, [openMandatoryModal]);

  useEffect(() => {
    if (isUsher && event && user?._id) {
      const currentUsherCheckIn = event.checkIns?.find(
        (checkIn) => checkIn.usherId?.toString() === user?._id?.toString()
      );

      if (currentUsherCheckIn) {
        const status = currentUsherCheckIn.approvalStatus;
        setUsherApprovalStatus(status);
      } else {
        setUsherApprovalStatus(null);
      }
    }
  }, [isUsher, event, user?._id, event?.checkIns]);

  useEffect(() => {
    if (!guests || !event?.invitations) {
      setEnrichedGuests(guests || []);
      return;
    }

    const enriched = guests.map((guest) => {
      const invitation = event.invitations.find((inv) => {
        if (inv.guestId?._id) {
          const match1 = inv.guestId._id === guest.id;
          const match2 = inv.guestId._id === guest.guestId;
          const match3 = inv.guestId._id === guest._id;
          if (match1 || match2 || match3) {
            return true;
          }
        }

        if (typeof inv.guestId === "string") {
          const match1 = inv.guestId === guest.id;
          const match2 = inv.guestId === guest.guestId;
          const match3 = inv.guestId === guest._id;
          if (match1 || match2 || match3) {
            return true;
          }
        }
        if (inv._id) {
          const match1 = inv._id === guest.id;
          const match2 = inv._id === guest.invitationId;
          if (match1 || match2) {
            return true;
          }
        }

        return false;
      });

      const isCheckedIn =
        invitation?.isCheckedIn === true ||
        invitation?.checkInStatus === "checked-in" ||
        guest.isCheckedIn === true ||
        false;

      const checkInTime = invitation?.checkInTime || guest.checkInTime || null;

      return {
        ...guest,
        isCheckedIn,
        checkInTime,
      };
    });

    setEnrichedGuests(enriched);
  }, [guests, event?.invitations]);

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePurchaseClick = (type, options) => {
    setMandatoryPurchaseData({ type, options });
  };

  const canGenerateTicket = () => {
    if (!invitation || eventStatus !== "accepted") return false;

    const hasRequiredAttire = event?.isEventAttireCompulsory
      ? invitation?.eventAttire?.some((attire) => attire.paid)
      : true;

    const hasRequiredTicket = event?.isEntryFeeApplicable
      ? invitation?.ticketFeePaid?.some((ticket) => ticket.paid)
      : true;

    return hasRequiredAttire && hasRequiredTicket;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let hasValidEventDate = false;

  if (event?.eventDate) {
    const eventDate = new Date(event.eventDate);
    eventDate.setHours(0, 0, 0, 0);

    hasValidEventDate = eventDate >= today;
  } else if (event?.startDate && event?.endDate) {
    const startDate = new Date(event.startDate);
    const endDate = new Date(event.endDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    hasValidEventDate = endDate >= today;
  } else if (event?.multipleDates?.length) {
    hasValidEventDate = event.multipleDates.some((d) => {
      const date = new Date(d.date);
      date.setHours(0, 0, 0, 0);
      return date >= today;
    });
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchTerm("");
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        downloadBtnRef.current &&
        !downloadBtnRef.current.contains(e.target)
      ) {
        setShowDownloadOptions(false);
      }
    };
    if (showDownloadOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDownloadOptions]);

  const filteredGuests = enrichedGuests.filter((guest) => {
    if (!searchTerm) return true;

    const searchLower = searchTerm.toLowerCase();
    const name = guest.name?.toLowerCase() || "";
    const phone = guest.phone?.toLowerCase() || "";
    const email = guest.email?.toLowerCase() || "";

    return (
      name.includes(searchLower) ||
      phone.includes(searchLower) ||
      email.includes(searchLower)
    );
  });

  const filteredRefunds = refunds.filter((refund) => {
    if (!searchTerm) return true;

    const searchLower = searchTerm.toLowerCase();
    const name = refund.name?.toLowerCase() || "";

    return name.includes(searchLower);
  });

  const handleRefundAction = async ({ eventId, refundId, action }) => {
    try {
      await axios.patch(`/event/${eventId}/refund/${refundId}`, {
        refundStatus: action,
      });

      setRefunds((prev) =>
        prev.map((r) =>
          r.refundDetails.refundId === refundId
            ? {
                ...r,
                refundDetails: {
                  ...r.refundDetails,
                  refundStatus: action,
                  responseDate: new Date().toISOString(),
                },
              }
            : r
        )
      );
    } catch (error) {
      // console.error("Refund action failed", error);
    }
  };

  const refreshEventDetails = () => {
    window.location.reload();
  };

  const invitationResponseSubmission = async (responseResult, eventId) => {
    try {
      const response = await axios.put(`/event/${eventId}/invitation/respond`, {
        guestId: guestId,
        status: responseResult,
      });

      if (response.data.successStatus) {
        setLoading(true);
        return true;
      } else {
        setError("Failed to submit response. Please try again.");
        return false;
      }
    } catch (error) {
      setError("Failed to submit response. Please try again.");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptProceed = async () => {
    setIsAcceptModalOpen(false);

    const success = await invitationResponseSubmission("accepted", eventId);
    if (!success) return;

    if (event?.isEventAttireCompulsory || event?.isEntryFeeApplicable) {
      setIsPurchaseModalOpen(true);
    } else {
      refreshEventDetails();
    }
  };

  const handleMandatoryPurchaseProceed = (purchaseData) => {
    setIsMandatoryPurchaseModalOpen(false);
    setSelectedPurchase(purchaseData);
    invitationResponseSubmission("accepted", eventId).then((success) => {
      if (success) {
        refreshEventDetails();
      }
    });
  };

  const handleMandatoryPurchasePayLater = () => {
    setIsMandatoryPurchaseModalOpen(false);
    invitationResponseSubmission("accepted", eventId).then((success) => {
      if (success) {
        refreshEventDetails();
      }
    });
  };

  const handleDeclineProceed = async () => {
    setIsDeclineModalOpen(true);
    await invitationResponseSubmission("declined", eventId);
  };

  const handleShareButtonPress = () => {
    const status = event?.approvalStatus;

    if (status === "approved") {
      setInviteSelectorVisible(true);
      return;
    }

    if (status === "pending") {
      setEventStatusModalType("pending");
      setEventStatusModalVisible(true);
      return;
    }

    if (status === "declined" || status === "rejected") {
      setEventStatusModalType(status);
      setEventStatusModalVisible(true);
      return;
    }
  };

  const handleEditEvent = () => {
    navigate(`/edit-event/${event._id}`);
    setEventStatusModalVisible(false);
  };

  const handleImInterestedClick = () => {
    if (hasAlreadyExpressedInterest()) {
      alert("You have already expressed interest in this event.");
      return;
    }

    const hasValidUser = isAuthenticated && user?._id;

    if (!hasValidUser) {
      if (isPaidEvent(event)) {
        initializePaidEventSession({
          eventId: event._id,
          eventTitle: event.eventTitle,
          isPaidEvent: true,
        });
        navigate("/signup", {
          state: {
            role: "guest",
            from: { pathname: `/eventManagementDetails/${event._id}` },
          },
        });
        return;
      }
      setIsContactModalOpen(true);
    } else if (isHost || isUsher) {
      setOriginalRoleBeforeSwitch(userRole);
      setShowRoleSwitchModal(true);
    } else {
      expressInterestDirectly(null);
    }
  };

  const handleLoginFromContactModal = () => {
    setIsContactModalOpen(false);
    navigate("/login", {
      state: {
        from: { pathname: `/eventManagementDetails/${event._id}` },
        role: "guest",
      },
    });
  };

  const acceptedGuests = guests.filter((g) => g.rsvpStatus === "accepted");
  const declinedGuests = guests.filter((g) => g.rsvpStatus === "declined");
  const pendingGuests = guests.filter((g) => g.rsvpStatus === "pending");

  const getStats = () => {
    const totalGuests =
      acceptedGuests.length + declinedGuests.length + pendingGuests.length;

    const totalCashGifts = acceptedGuests.reduce(
      (sum, guest) => sum + (guest.cashGiftAmount || 0),
      0
    );

    const totalEventAttire = acceptedGuests.reduce((sum, guest) => {
      if (guest.eventAttire === 0) return sum;
      return sum + (guest.eventAttire?.totalAmount || 0);
    }, 0);

    const totalTickets = acceptedGuests.reduce((sum, guest) => {
      if (guest.ticketFeePaid && guest.ticketFeePaid.length > 0) {
        return sum + (guest.ticketFeePaid[0]?.totalAmount || 0);
      }
      return sum;
    }, 0);

    const overallAmount = totalCashGifts + totalEventAttire + totalTickets;
    const refundRequests = refunds.length;

    const pendingRefunds = refunds.filter((r) => r.status === "Pending").length;
    const approvedRefunds = refunds.filter(
      (r) => r.status === "Approved" || r.status === "Paid"
    ).length;
    const totalRefundAmount = refunds.reduce(
      (sum, refund) => sum + (refund.amount || 0),
      0
    );

    const acceptanceRate =
      totalGuests > 0
        ? ((acceptedGuests.length / totalGuests) * 100).toFixed(2)
        : 0;

    return {
      totalGuests,
      acceptedGuests: acceptedGuests.length,
      declinedGuests: declinedGuests.length,
      pendingGuests: pendingGuests.length,
      overallAmount,
      totalCashGifts,
      totalEventAttire,
      totalTickets,
      refundRequests,
      pendingRefunds,
      approvedRefunds,
      totalRefundAmount,
      acceptanceRate,
      netRevenue:
        overallAmount -
        refunds
          .filter((r) => r.status === "Approved" || r.status === "Paid")
          .reduce((sum, refund) => sum + (refund.amount || 0), 0),
    };
  };

  const downloadPDF = () => {
    const stats = getStats();
    const totalCashGifts = acceptedGuests.reduce(
      (sum, guest) => sum + (guest.cashGiftAmount || 0),
      0
    );
    const totalEventAttire = acceptedGuests.reduce((sum, guest) => {
      if (guest.eventAttire === 0) return sum;
      return sum + (guest.eventAttire?.totalAmount || 0);
    }, 0);
    const totalTickets = acceptedGuests.reduce((sum, guest) => {
      if (guest.ticketFeePaid && guest.ticketFeePaid.length > 0) {
        return sum + (guest.ticketFeePaid[0]?.totalAmount || 0);
      }
      return sum;
    }, 0);
    const responseStatus = acceptedGuests.rsvpStatus
      ? acceptedGuests.rsvpStatus.charAt(0).toUpperCase() +
        acceptedGuests.rsvpStatus.slice(1)
      : "Accepted";
    const totalRevenue = totalCashGifts + totalEventAttire + totalTickets;
    const pendingRefundAmount = refunds
      .filter((r) => r.status === "Pending")
      .reduce((sum, refund) => sum + (refund.amount || 0), 0);
    const approvedRefundAmount = refunds
      .filter((r) => r.status === "Approved" || r.status === "Paid")
      .reduce((sum, refund) => sum + (refund.amount || 0), 0);
    const htmlContent = generateHtmlReport({
      event,
      stats,
      acceptedGuests,
      declinedGuests,
      refunds,
      formatCurrency,
      formatDate,
      formatDateWithOrdinal,
      getEventStatus,
      totalRevenue,
      totalCashGifts,
      totalEventAttire,
      totalTickets,
      pendingRefundAmount,
      approvedRefundAmount,
      responseStatus,
      usherStats,
    });
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    } else {
      alert("Please allow pop-ups to download the PDF report.");
    }
    setShowDownloadOptions(false);
  };

  const downloadCSV = () => {
    eventDetailsDownloadCSV({
      event,
      acceptedGuests,
      declinedGuests,
      pendingGuests,
      refunds,
      getEventStatus,
      formatDate,
      formatDateWithOrdinal,
      usherStats,
    });
    setShowDownloadOptions(false);
  };

  const handleRoleSwitchConfirm = async () => {
    setShowRoleSwitchModal(false);
    setIsRoleSwitching(true);

    try {
      const updatedRoles = Array.from(
        new Set([...(user?.role || []), "guest"])
      );

      await axios.patch(
        `/user/${user._id}`,
        { role: updatedRoles },
        { headers: { "Content-Type": "application/json" } }
      );

      const updatedUser = {
        ...user,
        role: updatedRoles,
        activeRole: "guest",
      };

      setUser(updatedUser);
      localStorage.setItem("user", JSON.stringify(updatedUser));

      await expressInterestDirectly(originalRoleBeforeSwitch);
    } catch (error) {
      // console.error("Error during role switch:", error);
      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to switch role. Please try again."
      );
    } finally {
      setIsRoleSwitching(false);
      setOriginalRoleBeforeSwitch(null);
    }
  };

  const expressInterestDirectly = async (roleBeforeSwitch = null) => {
    if (!event) return;

    try {
      setIsSubmittingInterest(true);

      const wasRoleSwitch =
        roleBeforeSwitch !== null && roleBeforeSwitch !== "guest";

      const payload = {
        guestId: user?._id,
        status: "accepted",
        numberOfGuests: 1,
        isPublicEventInterest: true,
        roleSwitchConfirmed: wasRoleSwitch,
        originalRole: roleBeforeSwitch,
      };

      const response = await axios.put(
        `/event/${eventId}/invitation/respond`,
        payload
      );

      if (response.data.success || response.data.successStatus) {
        const requiresPayment =
          response.data.data?.requiresPayment || response.data.requiresPayment;

        setSuccessMessage({
          title: "Success! 🎉",
          message: requiresPayment
            ? "You've successfully expressed interest! Please complete payment to confirm your attendance."
            : "You've successfully expressed interest in this event!",
        });

        setHasShownInterest(false);
        setIsContactModalOpen(false);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setIsSuccessModalOpen(true);
          });
        });
      }
    } catch (error) {
      if (
        error.response?.data?.data?.alreadyInterested ||
        error.response?.status === 409
      ) {
        alert("You have already expressed interest in this event.");
      } else {
        alert(
          error.response?.data?.message ||
            "Failed to express interest. Please try again."
        );
      }
    } finally {
      setIsSubmittingInterest(false);
    }
  };

  const handleContactSubmit = async (contactInfo) => {
    if (!event) {
      alert("Event details not found");
      return;
    }

    try {
      setIsSubmittingInterest(true);

      const response = await axios.put(
        `/event/${event._id}/invitation/respond`,
        {
          status: "accepted",
          numberOfGuests: 1,
          isPublicEventInterest: true,
          contactInfo: {
            firstName: contactInfo.firstName,
            lastName: contactInfo.lastName,
            email: contactInfo.email,
            phoneNumber: contactInfo.phoneNumber || "",
          },
        }
      );

      if (response.data.success || response.data.successStatus) {
        const message =
          response.data.message ||
          "Your interest has been registered! Check your email for your event ticket with QR code.";

        setSuccessMessage({
          title: "Success! 🎉",
          message: message,
        });
        setHasShownInterest(false);

        setIsContactModalOpen(false);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setIsSuccessModalOpen(true);
          });
        });
      } else {
        setIsContactModalOpen(false);
        alert("Registration failed. Please try again.");
      }
    } catch (error) {
      if (error.response?.status === 409) {
        setIsContactModalOpen(false);

        setHasShownInterest(false);

        alert(
          "Already Registered\n\n" +
            (error.response.data.message ||
              "You have already expressed interest in this event. Check your email for your ticket.")
        );
        return;
      }

      setIsContactModalOpen(false);
      alert(
        error.response?.data?.message ||
          error.message ||
          "Failed to register your interest. Please try again."
      );
    } finally {
      setIsSubmittingInterest(false);
    }
  };

  const handleSuccessModalClose = () => {
    if (onRefresh && typeof onRefresh === "function") {
      setIsSuccessModalOpen(false);

      setTimeout(() => {
        onRefresh();
      }, 100);
      return;
    }

    setIsSuccessModalOpen(false);

    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const handleOpenScanner = () => {
    if (isHost && event?.approvalStatus !== "approved") {
      alert(
        "Event Not Approved: You can only check in guests once your event has been approved by admin. Please wait for approval."
      );
      return;
    }

    if (isUsher && !isUsherApproved) {
      alert(
        "Approval Required: You need host approval before you can check in guests. Please wait for the host to confirm your usher status."
      );
      return;
    }
    setScannerVisible(true);
  };

  const isGuestAlreadyCheckedIn = (guestId) => {
    const guest = enrichedGuests.find(
      (g) => g.guestId === guestId || g.id === guestId || g._id === guestId
    );

    return {
      isCheckedIn: guest?.isCheckedIn === true,
      checkInTime: guest?.checkInTime || null,
      guestName: guest?.name || "Guest",
    };
  };

  const handleScanSuccess = (qrData) => {
    setScannerVisible(false);

    const localStatus = isGuestAlreadyCheckedIn(qrData.guestId);

    if (localStatus.isCheckedIn) {
      const checkInTimeStr = localStatus.checkInTime
        ? ` at ${new Date(localStatus.checkInTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}`
        : "";

      alert(
        `Already Checked In: ${localStatus.guestName} has already been checked in${checkInTimeStr}`
      );

      if (onRefresh) {
        onRefresh();
      }
      return;
    }

    const guestDetails = enrichedGuests.find(
      (g) =>
        g.guestId === qrData.guestId ||
        g.id === qrData.guestId ||
        g._id === qrData.guestId
    );

    const enrichedQRData = {
      ...qrData,
      guestEmail: guestDetails?.email || qrData.guestEmail || null,
    };

    setScannedGuestData(enrichedQRData);
    setConfirmationModalVisible(true);
  };

  const handleConfirmCheckIn = async (guestData) => {
    setIsCheckingIn(true);

    try {
      if (event && enrichedGuests) {
        const updatedGuests = enrichedGuests.map((guest) => {
          const isTargetGuest =
            guest.guestId === guestData.guestId ||
            guest.id === guestData.guestId ||
            guest._id === guestData.guestId;

          return isTargetGuest
            ? {
                ...guest,
                isCheckedIn: true,
                checkInTime: new Date().toISOString(),
                checkInMethod: "QR Code",
              }
            : guest;
        });

        setEnrichedGuests(updatedGuests);
      }

      const response = await axios.post(
        `/checkin/event/${event._id}/check-in`,
        {
          guestId: guestData.guestId,
          userId: user?._id,
          checkInTime: new Date().toISOString(),
          viaQRCode: true,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data?.successStatus === true) {
        alert(
          `✓ Guest checked in successfully!\n\n${guestData.guestName} has been checked in.`
        );

        setConfirmationModalVisible(false);
        setScannedGuestData(null);

        if (onRefresh) {
          onRefresh();
        } else {
          window.location.reload();
        }
      } else {
        alert(response.data.message || "Check-in failed");
      }
    } catch (error) {
      if (event && enrichedGuests) {
        const revertedGuests = enrichedGuests.map((guest) => {
          const isTargetGuest =
            guest.guestId === guestData.guestId ||
            guest.id === guestData.guestId ||
            guest._id === guestData.guestId;

          return isTargetGuest
            ? {
                ...guest,
                isCheckedIn: false,
                checkInTime: null,
                checkInMethod: undefined,
              }
            : guest;
        });

        setEnrichedGuests(revertedGuests);
      }

      let errorMsg = "Failed to check in guest";

      if (error.response?.status === 409) {
        errorMsg = "This guest has already been checked in.";
      } else if (error.response?.status === 404) {
        errorMsg = "Guest or event not found. Please try again.";
      } else if (error.response?.status === 401) {
        errorMsg = "Session expired. Please log in again.";
      } else if (error.response?.status === 403) {
        errorMsg =
          "You don't have permission to check in guests for this event.";
      } else if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error.message) {
        errorMsg = error.message;
      }

      alert(`✗ Check-in Failed\n\n${errorMsg}`);

      setConfirmationModalVisible(false);
      setScannedGuestData(null);

      if (onRefresh) {
        onRefresh();
      }
    } finally {
      setIsCheckingIn(false);
    }
  };

  const closeModal = () => {
    setModalType(null);
  };

  const renderTabs = () => {
    return (
      <>
        <div className="event-detailed-detailed-event-tabs">
          <div className="event-detailed-detailed-event-tabs-2">
            <>
              {isHost && !isPublicEventNotOwnedByUser() && (
                <div className="event-detailed-tabs-container">
                  <button
                    className={`event-detailed-tab ${
                      activeTab === "about" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => handleTabChange("about")}
                  >
                    About Event
                  </button>

                  <button
                    className={`event-detailed-tab ${
                      activeTab === "guest" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => handleTabChange("guest")}
                  >
                    Guest
                  </button>

                  <button
                    className={`event-detailed-tab ${
                      activeTab === "usher" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => setActiveTab("usher")}
                  >
                    Usher
                  </button>

                  <button
                    className={`event-detailed-tab ${
                      activeTab === "refund" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => handleTabChange("refund")}
                  >
                    Refund
                  </button>
                </div>
              )}

              {isHost && isPublicEventNotOwnedByUser() && (
                <button
                  className="event-detailed-tab event-detailed-active"
                  onClick={() => handleTabChange("about")}
                >
                  About Event
                </button>
              )}

              {isUsher && !isHost && (
                <>
                  <button
                    className={`event-detailed-tab ${
                      activeTab === "about" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => handleTabChange("about")}
                  >
                    About Event
                  </button>
                  {isUsherApproved && (
                    <button
                      className={`event-detailed-tab ${
                        activeTab === "guest" ? "event-detailed-active" : ""
                      }`}
                      onClick={() => handleTabChange("guest")}
                    >
                      Guest List
                    </button>
                  )}
                </>
              )}

              {isGuest && !isHost && !isUsher && (
                <>
                  <button
                    className={`event-detailed-tab ${
                      activeTab === "about" ? "event-detailed-active" : ""
                    }`}
                    onClick={() => handleTabChange("about")}
                  >
                    About Event
                  </button>

                  {eventStatus === "accepted" && (
                    <button
                      className={`event-detailed-tab ${
                        activeTab === "others" ? "event-detailed-active" : ""
                      }`}
                      onClick={() => handleTabChange("others")}
                    >
                      Payments
                    </button>
                  )}
                </>
              )}

              {effectiveIsUnauthenticated && (
                <button
                  className="event-detailed-tab event-detailed-active"
                  onClick={() => handleTabChange("about")}
                >
                  About Event
                </button>
              )}
            </>

            <div className="event-detailed-refund-search-wrapper">
              {(activeTab === "guest" || activeTab === "refund") &&
                !isMobile && (
                  <div className="event-detailed-tab-selector-search">
                    <input
                      type="text"
                      className="event-detailed-tab-selector-search-input"
                      placeholder={
                        activeTab === "refund"
                          ? "Search refunds..."
                          : "Search guests..."
                      }
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                    <span className="event-detailed-tab-selector-search-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                      </svg>
                    </span>
                  </div>
                )}
            </div>

            {isHost && !isPublicEventNotOwnedByUser() && !isMobile && (
              <div className="detailed-event-download-container">
                <button
                  className="detailed-event-download-btn"
                  onClick={downloadReport}
                >
                  Download Report
                </button>
                {showDownloadOptions && (
                  <div className="detailed-event-download-options">
                    <button
                      className="detailed-event-download-option"
                      onClick={downloadCSV}
                    >
                      📊 Download CSV
                    </button>
                    <button
                      className="detailed-event-download-option"
                      onClick={downloadPDF}
                    >
                      📄 Download PDF
                    </button>
                  </div>
                )}
              </div>
            )}

            {isHost && !isPublicEventNotOwnedByUser() && isMobile && (
              <div style={{ flexShrink: 0, marginLeft: "auto" }}>
                <button
                  ref={downloadBtnRef}
                  className="detailed-event-download-btn"
                  onClick={downloadReport}
                >
                  Download
                </button>
                {showDownloadOptions && (
                  <div
                    className="detailed-event-download-options"
                    style={{
                      position: "fixed",
                      top: dropdownPos.top,
                      right: dropdownPos.right,
                      zIndex: 9999,
                    }}
                  >
                    <button
                      className="detailed-event-download-option"
                      onPointerDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        downloadCSV();
                      }}
                    >
                      📊 Download CSV
                    </button>

                    <button
                      className="detailed-event-download-option"
                      onPointerDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        downloadPDF();
                      }}
                    >
                      📄 Download PDF
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const renderMultipleDatesSection = () => {
    if (event?.dateOption !== "multiple" || !event?.multipleDates) return null;

    return (
      <div className="event-detailed-multiple-dates-section">
        <h3>Event Schedule</h3>
        <p className="event-detailed-multiple-dates-subtitle">
          This event has multiple dates and locations
        </p>
        <div className="event-detailed-multiple-dates-container">
          {event.multipleDates.map((dateEntry, index) => {
            let formattedDate = "Date TBD";
            if (dateEntry.date) {
              const dateStr =
                typeof dateEntry.date === "string"
                  ? dateEntry.date
                  : dateEntry.date.$date || dateEntry.date;

              try {
                const dateObj = new Date(dateStr);
                formattedDate = dateObj.toLocaleDateString("en-US", {
                  weekday: "short",
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  timeZone: "UTC",
                });
              } catch (error) {
                formattedDate = "Date TBD";
              }
            }

            const isSelected = selectedScheduleIndex === index;

            return (
              <div
                key={index}
                className={`event-detailed-multiple-date-card${
                  isSelected ? " event-detailed-multiple-date-card--active" : ""
                }`}
                onClick={() => setSelectedScheduleIndex(index)}
                style={{
                  cursor: "pointer",
                  outline: isSelected ? "2px solid #0e6a36" : "none",
                }}
              >
                <div className="event-detailed-multiple-date-header">
                  <span className="event-detailed-date-number">
                    {index + 1}
                  </span>
                  <h4>{dateEntry.subTitle || `Event ${index + 1}`}</h4>
                </div>

                <div className="event-detailed-multiple-date-info">
                  <div className="event-detailed-date-time-row">
                    <div className="event-detailed-date-info-item">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                          fill="#0e6a36"
                        />
                      </svg>
                      <span>{formattedDate}</span>
                    </div>

                    <div className="event-detailed-date-info-item">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          fill="#0e6a36"
                        />
                        <path
                          d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                          fill="#0e6a36"
                        />
                      </svg>
                      <span>{dateEntry.time || "Time TBD"}</span>
                    </div>
                  </div>

                  {(dateEntry.landmark || dateEntry.location) && (
                    <div className="event-detailed-location-info-item">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                          fill="#0e6a36"
                        />
                      </svg>
                      <div className="event-detailed-location-text">
                        {dateEntry.landmark && (
                          <p className="event-detailed-landmark">
                            {dateEntry.landmark}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderStartEndDateSection = () => {
    if (event?.dateOption !== "range" && event?.dateOption !== "startEnd") {
      return null;
    }

    if (!event?.startDate && !event?.endDate) {
      return null;
    }

    return (
      <div className="event-detailed-multiple-dates-section">
        <h3>Event Schedule</h3>
        <p className="event-detailed-multiple-dates-subtitle">
          This event spans multiple dates
        </p>
        <div className="event-detailed-multiple-dates-container">
          <div className="event-detailed-multiple-date-card">
            <div className="event-detailed-multiple-date-header">
              <span className="event-detailed-date-number">1</span>
              <h4>Start Date</h4>
            </div>

            <div className="event-detailed-multiple-date-info">
              <div className="event-detailed-date-time-row">
                <div className="event-detailed-date-info-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                      fill="#0e6a36"
                    />
                  </svg>
                  <span>
                    {event?.startDate
                      ? new Date(event.startDate).toLocaleDateString("en-US", {
                          weekday: "short",
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          timeZone: "UTC",
                        })
                      : "Date TBD"}
                  </span>
                </div>

                <div className="event-detailed-date-info-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                      fill="#0e6a36"
                    />
                    <path
                      d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                      fill="#0e6a36"
                    />
                  </svg>
                  <span>
                    {event?.eventTime || event?.startTime || "Time TBD"}
                  </span>
                </div>
              </div>

              {event?.dateOption == "startEnd" && (
                <div className="event-detailed-location-info-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                      fill="#0e6a36"
                    />
                  </svg>
                  <div className="event-detailed-location-text">
                    {(event?.eventLandmark ||
                      event?.eventLocation ||
                      event?.customAddress) && (
                      <p className="event-detailed-landmark">
                        {event?.eventLandmark ||
                          event?.eventLocation ||
                          event?.customAddress}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="event-detailed-multiple-date-card">
            <div className="event-detailed-multiple-date-header">
              <span className="event-detailed-date-number">2</span>
              <h4>End Date</h4>
            </div>

            <div className="event-detailed-multiple-date-info">
              <div className="event-detailed-date-time-row">
                <div className="event-detailed-date-info-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                      fill="#0e6a36"
                    />
                  </svg>
                  <span>
                    {event?.endDate
                      ? new Date(event.endDate).toLocaleDateString("en-US", {
                          weekday: "short",
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          timeZone: "UTC",
                        })
                      : "Date TBD"}
                  </span>
                </div>
              </div>

              {event?.dateOption === "startEnd" && (
                <div className="event-detailed-location-info-item">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                      fill="#0e6a36"
                    />
                  </svg>
                  <div className="event-detailed-location-text">
                    {(event?.eventLandmark ||
                      event?.eventLocation ||
                      event?.customAddress) && (
                      <p className="event-detailed-landmark">
                        {event?.eventLandmark ||
                          event?.eventLocation ||
                          event?.customAddress}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEventHeader = () => {
    const getFirstDate = () => {
      if (
        event?.dateOption === "multiple" &&
        event?.multipleDates?.length > 0
      ) {
        const sortedDates = [...event.multipleDates].sort((a, b) => {
          const dateA = new Date(a.date?.$date || a.date || a.startDate);
          const dateB = new Date(b.date?.$date || b.date || b.startDate);
          return dateA - dateB;
        });
        return sortedDates[0];
      }
      return null;
    };

    const firstDate = getFirstDate();

    const formatDisplayDate = (dateString) => {
      if (!dateString) return "Date TBD";

      try {
        const dateObj = new Date(dateString);
        return dateObj.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
          timeZone: "UTC",
        });
      } catch (error) {
        return "Date TBD";
      }
    };

    let displayDate, displayTime, displayLocation;

    if (event?.dateOption === "multiple") {
      if (firstDate) {
        displayDate = formatDisplayDate(
          firstDate.date?.$date || firstDate.date || firstDate.startDate
        );
        displayTime = firstDate.time || firstDate.eventTime || "Time TBD";
        displayLocation =
          firstDate.landmark ||
          firstDate.location ||
          firstDate.customAddress ||
          "Location TBD";
      } else {
        displayDate = "Multiple Dates";
        displayTime = "Multiple Times";
        displayLocation = "Multiple Locations";
      }
    } else if (event?.dateOption === "range") {
      displayDate = `${formatDisplayDate(
        event?.startDate
      )} - ${formatDisplayDate(event?.endDate)}`;
      displayTime = event?.eventTime || event?.startTime || "Time TBD";
      displayLocation =
        event?.eventLandmark ||
        event?.eventLocation ||
        event?.customAddress ||
        "Location TBD";
    } else {
      displayDate = formatDisplayDate(event?.eventDate || event?.startDate);
      displayTime = event?.eventTime || event?.startTime || "Time TBD";
      displayLocation =
        event?.eventLandmark ||
        event?.eventLocation ||
        event?.customAddress ||
        "Location TBD";
    }

    return (
      <div className="event-detailed-detailed-event-header">
        <h1>{event?.eventTitle || "Untitled Event"}</h1>
        <div className="event-detailed-detailed-event-details">
          <div className="event-detailed-detailed-event-time">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                fill="currentColor"
              />
              <path
                d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                fill="currentColor"
              />
            </svg>
            {displayTime}
          </div>
          <div className="event-detailed-detailed-event-location">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                fill="currentColor"
              />
            </svg>
            {displayLocation}
          </div>
        </div>
        <div className="event-detailed-detailed-event-date">
          <span>{displayDate}</span>
        </div>
      </div>
    );
  };

  const renderEventImage = () => (
    <div className="event-detailed-detailed-event-image-container">
      <img
        src={event?.eventImages?.[0]?.uri || "/images/eventImage.jpg"}
        alt="Event"
        className="event-detailed-detailedEvent-event-image"
      />
    </div>
  );

  const renderColorOfTheDay = () => {
    const colorOfTheDay = event?.colorOfTheDay;

    if (
      (isGuest || isUsher) &&
      (!colorOfTheDay || colorOfTheDay.trim() === "")
    ) {
      return null;
    }

    if (isHost) {
      return (
        <div className="event-detailed-event-detail-section">
          <h3>Color of the Day:</h3>
          {colorOfTheDay && colorOfTheDay.trim() !== "" ? (
            <div className="event-detailed-color-of-day-container">
              <p className="event-detailed-color-name">{colorOfTheDay}</p>
            </div>
          ) : (
            <div className="event-detailed-color-of-day-container">
              <p className="event-detailed-color-not-selected">Not Selected</p>
            </div>
          )}
        </div>
      );
    }

    if (colorOfTheDay && colorOfTheDay.trim() !== "") {
      return (
        <div className="event-detailed-event-detail-section">
          <h3>Color of the Day:</h3>
          <div className="event-detailed-color-of-day-container">
            <p className="event-detailed-color-name">{colorOfTheDay}</p>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderEventDescription = () => {
    const getActiveScheduleEntry = () => {
      if (
        event?.dateOption === "multiple" &&
        event?.multipleDates?.length > 0
      ) {
        return (
          event.multipleDates[selectedScheduleIndex] || event.multipleDates[0]
        );
      }
      return null;
    };

    const getActiveMapCoords = () => {
      const entry = getActiveScheduleEntry();

      if (entry) {
        if (
          entry?.landmarkCoords?.latitude &&
          entry?.landmarkCoords?.longitude
        ) {
          return {
            latitude: Number(entry.landmarkCoords.latitude),
            longitude: Number(entry.landmarkCoords.longitude),
          };
        }
        if (entry?.landmarkCoords?.coordinates?.length === 2) {
          return {
            latitude: Number(entry.landmarkCoords.coordinates[1]),
            longitude: Number(entry.landmarkCoords.coordinates[0]),
          };
        }
        if (entry?.latitude && entry?.longitude) {
          return {
            latitude: Number(entry.latitude),
            longitude: Number(entry.longitude),
          };
        }
        const geoSource =
          entry?.googleLandmark?.coordinates ||
          entry?.eventGoogleLandmark?.coordinates ||
          entry?.coordinates;
        if (Array.isArray(geoSource) && geoSource.length === 2) {
          return {
            latitude: Number(geoSource[1]),
            longitude: Number(geoSource[0]),
          };
        }
        return { latitude: null, longitude: null };
      }

      const coordinates = event?.eventGoogleLandmark?.coordinates;
      return {
        latitude: coordinates?.[0] ?? null,
        longitude: coordinates?.[1] ?? null,
      };
    };

    const { latitude, longitude } = getActiveMapCoords();

    const getEventLocation = () => {
      if (
        event?.dateOption === "multiple" &&
        event?.multipleDates?.length > 0
      ) {
        const entry = getActiveScheduleEntry();
        return (
          (typeof entry?.landmark === "string" && entry.landmark.trim()
            ? entry.landmark
            : null) ||
          (typeof entry?.location === "string" && entry.location.trim()
            ? entry.location
            : null) ||
          (typeof entry?.customAddress === "string" &&
          entry.customAddress.trim()
            ? entry.customAddress
            : null)
        );
      }
      return (
        event?.eventLocation || event?.eventLandmark || event?.customAddress
      );
    };

    const fullAddress = getEventLocation();

    const getMapQuery = () => {
      if (event?.dateOption === "multiple") {
        const entry = getActiveScheduleEntry();
        const addressForMap =
          (typeof entry?.landmark === "string" && entry.landmark.trim()
            ? entry.landmark
            : null) ||
          (typeof entry?.location === "string" && entry.location.trim()
            ? entry.location
            : null);
        if (addressForMap) return encodeURIComponent(addressForMap);
      }
      if (latitude && longitude) return `${latitude},${longitude}`;
      if (fullAddress) return encodeURIComponent(fullAddress);
      return null;
    };

    const mapQuery = getMapQuery();
    const mapsHref = mapQuery
      ? `https://www.google.com/maps/search/?api=1&query=${mapQuery}`
      : null;

    return (
      <div className="event-detailed-detailed-event-description">
        <h2>About Event</h2>
        <p>{event?.eventDescription || "No description available."}</p>

        {renderMultipleDatesSection()}
        {renderStartEndDateSection()}

        {(isGuest || isHost) && event?.preferredCurrency && (
          <div className="event-detailed-event-currency-display">
            <h3>Event Currency: </h3>
            <div className="event-detailed-currency-badge">
              {event.preferredCurrency === "NGN"
                ? "Nigerian Naira (₦)"
                : "US Dollar ($)"}
            </div>
          </div>
        )}

        {fullAddress && (
          <div className="event-detailed-event-detail-section">
            <h3>Full Address: </h3>
            <div className="event-detailed-event-detail-content">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                  fill="#0e6a36"
                />
              </svg>
              <p>{fullAddress}</p>
            </div>
          </div>
        )}

        {renderColorOfTheDay()}

        {mapQuery && (
          <div className="event-detailed-event-detail-section">
            <div className="event-detailed-location-map-container">
              <iframe
                key={`map-${selectedScheduleIndex}-${mapQuery}`}
                width="100%"
                height="300"
                frameBorder="0"
                style={{ border: 0, borderRadius: "8px" }}
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                allowFullScreen
                title="Event Location Map"
              ></iframe>

              <a
                href={mapsHref}
                target="_blank"
                rel="noopener noreferrer"
                className="event-detailed-open-in-maps-btn"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                    fill="currentColor"
                  />
                </svg>
                Open in Google Maps
              </a>
            </div>
          </div>
        )}

        {isHost && !isPublicEventNotOwnedByUser() && (
          <GiftComponent
            event={event}
            paymentDetails={event?.invitations || []}
          />
        )}

        {(isGuest || isUsher || effectiveIsUnauthenticated) && (
          <HostProfile hostId={event?.userId} />
        )}

        {isPaidEvent(event) &&
          effectiveIsUnauthenticated &&
          !shouldShowInterestedForAuthUser() &&
          !isUsherJoinedEvent && (
            <div className="event-detailed-paid-event-notice">
              <div className="event-detailed-paid-event-icon">💳</div>
              <div className="event-detailed-paid-event-content">
                <h4>Paid Event</h4>
                <p>Payment will be required to confirm your attendance.</p>
                {event.isEntryFeeApplicable && event.ticketFee?.length > 0 && (
                  <span className="event-detailed-payment-item">
                    🎟️ Entry Ticket Required
                  </span>
                )}
                {event.isEventAttireCompulsory &&
                  event.isEventAttireAvailable && (
                    <span className="event-detailed-payment-item">
                      👔 Event Attire Required
                    </span>
                  )}
                {event.isCashGiftAccepted &&
                  event.cashGiftData?.bankDetails && (
                    <span className="event-detailed-payment-item">
                      🎁 Cash Gift Accepted
                    </span>
                  )}
              </div>
            </div>
          )}

        {isPaidEvent(event) && shouldShowInterestedForAuthUser() && (
          <div className="event-detailed-paid-event-notice">
            <div className="event-detailed-paid-event-icon">💳</div>
            <div className="event-detailed-paid-event-content">
              <h4>Paid Event</h4>
              <p>Payment will be required to confirm your attendance.</p>
              {event.isEntryFeeApplicable && event.ticketFee?.length > 0 && (
                <span className="event-detailed-payment-item">
                  🎟️ Entry Ticket Required
                </span>
              )}
              {event.isEventAttireCompulsory &&
                event.isEventAttireAvailable && (
                  <span className="event-detailed-payment-item">
                    👔 Event Attire Required
                  </span>
                )}
              {event.isCashGiftAccepted && event.cashGiftData?.bankDetails && (
                <span className="event-detailed-payment-item">
                  🎁 Cash Gift Accepted
                </span>
              )}
            </div>
          </div>
        )}

        {isGuest && canGenerateTicket() && hasValidEventDate && (
          <div className="event-detailed-generate-ticket-section">
            <button
              className="event-detailed-generate-ticket-button"
              onClick={() => setShowDigitalTicket(true)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                  fill="currentColor"
                />
              </svg>
              Generate Ticket
            </button>
          </div>
        )}

        {isGuest &&
          eventStatus === "accepted" &&
          !canGenerateTicket() &&
          (event?.isEventAttireCompulsory || event?.isEntryFeeApplicable) && (
            <div className="event-detailed-payment-required-notice">
              <div className="event-detailed-payment-required-icon">💳</div>
              <div className="event-detailed-payment-required-content">
                <h4>Complete Your Registration</h4>
                <p>
                  {event?.isEventAttireCompulsory && event?.isEntryFeeApplicable
                    ? "Event Attire and Ticket are mandatory. Complete both purchases to generate your ticket."
                    : event?.isEventAttireCompulsory
                    ? "Event Attire is mandatory. Complete your purchase to generate your ticket."
                    : event?.isEntryFeeApplicable
                    ? "Ticket purchase is mandatory. Complete your purchase to generate your ticket."
                    : "Complete your required purchases to generate your ticket."}
                </p>
                <button
                  className="event-detailed-complete-payment-btn"
                  onClick={() => handleTabChange("others")}
                >
                  Go to Payments
                </button>
              </div>
            </div>
          )}

        {effectiveIsUnauthenticated &&
          hasValidEventDate &&
          !shouldShowInterestedForAuthUser() &&
          !isUsherJoinedEvent &&
          event?.visibility === "public" && (
            <div className="event-detailed-unauthenticated-actions">
              <button
                className={`event-detailed-im-interested-btn ${
                  hasShownInterest ? "event-detailed-interest-shown" : ""
                }`}
                onClick={handleImInterestedClick}
                disabled={isSubmittingInterest || hasShownInterest}
              >
                {isSubmittingInterest ? "Submitting..." : "I'm Interested"}
              </button>
            </div>
          )}

        {shouldShowInterestedForAuthUser() && hasValidEventDate && (
          <div className="event-detailed-unauthenticated-actions">
            {hasAlreadyExpressedInterest() ? (
              <button
                className="event-detailed-im-interested-btn event-detailed-interest-shown"
                disabled
              >
                ✓ Interest Expressed
              </button>
            ) : (
              <button
                className="event-detailed-im-interested-btn"
                onClick={handleImInterestedClick}
                disabled={isSubmittingInterest || isRoleSwitching}
              >
                {isSubmittingInterest || isRoleSwitching
                  ? "Processing..."
                  : "I'm Interested"}
              </button>
            )}
            {(isHost || isUsher) && (
              <p className="event-detailed-role-switch-hint">
                You'll be switched to a Guest role for this event
              </p>
            )}
          </div>
        )}

        {(isHost || isUsher || isGuest) && (
          <div className="event-detailed-detailed-event-actions">
            {isHost && !isPublicEventNotOwnedByUser() && (
              <>
                <div className="event-detailed-host-actions-row">
                  <button
                    className="event-detailed-edit-btn-mobile"
                    onClick={handleEditEvent}
                  >
                    Edit Event
                  </button>
                  {hasValidEventDate && (
                    <button
                      className={`event-detailed-share-btn-mobile ${
                        event?.approvalStatus === "pending"
                          ? "share-btn-disabled"
                          : ""
                      }`}
                      onClick={handleShareButtonPress}
                    >
                      {event?.approvalStatus === "pending"
                        ? "Event Pending"
                        : "Share Invite Link"}
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>
                  )}
                </div>

                <button
                  className={`event-detailed-checkin-guest-btn-mobile-full ${
                    event?.approvalStatus !== "approved" || !hasValidEventDate
                      ? "event-detailed-disabled"
                      : ""
                  }`}
                  onClick={handleOpenScanner}
                  disabled={
                    event?.approvalStatus !== "approved" || !hasValidEventDate
                  }
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM13 13h2v2h-2v-2zM15 15h2v2h-2v-2zM13 17h2v2h-2v-2zM15 19h2v2h-2v-2zM17 13h2v2h-2v-2zM19 15h2v2h-2v-2zM17 17h2v2h-2v-2zM19 19h2v2h-2v-2z"
                      fill="currentColor"
                    />
                  </svg>
                  Check-In Guest
                </button>
              </>
            )}

            {isUsher && !isHost && isUsherJoinedEvent && (
              <div className="event-detailed-usher-action-container">
                <button
                  className={`event-detailed-checkin-guest-btn-mobile ${
                    !isUsherApproved || !hasValidEventDate
                      ? "event-detailed-disabled"
                      : ""
                  }`}
                  onClick={handleOpenScanner}
                  disabled={!isUsherApproved || !hasValidEventDate}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM13 13h2v2h-2v-2zM15 15h2v2h-2v-2zM13 17h2v2h-2v-2zM15 19h2v2h-2v-2zM17 13h2v2h-2v-2zM19 15h2v2h-2v-2zM17 17h2v2h-2v-2zM19 19h2v2h-2v-2z"
                      fill="currentColor"
                    />
                  </svg>
                  Check-In Guest
                </button>

                <div className="event-detailed-usher-approval-notice">
                  {isUsherRejected ? (
                    <p className="event-detailed-usher-rejected-text">
                      Your usher access has been declined by the host. Please
                      contact the event organizer for assistance.
                    </p>
                  ) : isUsherApproved ? (
                    <p className="event-detailed-usher-approved-text">
                      Your usher access has been approved! You can now check in
                      guests.
                    </p>
                  ) : isUsherPending ? (
                    <p className="event-detailed-usher-pending-text">
                      Your request is pending host approval. You'll be able to
                      check in guests once the host confirms your usher status.
                    </p>
                  ) : null}
                </div>
              </div>
            )}

            {isGuest &&
              !isPublicEventNotOwnedByUser() &&
              !hasValidEventDate &&
              (eventStatus === "pending" || eventStatus === "declined") && (
                <div className="event-detailed-details-buttons-container">
                  <button
                    onClick={handleDeclineProceed}
                    className="event-detailed-details-invite-decline-button"
                    disabled={eventStatus === "declined"}
                  >
                    Decline
                  </button>
                  <button
                    className="event-detailed-details-invite-accept-button"
                    onClick={handleAcceptProceed}
                    disabled={eventStatus === "accepted"}
                  >
                    Accept
                  </button>
                </div>
              )}
          </div>
        )}

        {isGuest && event?.userId === user?._id && (
          <div className="event-detailed-owner-notice">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                fill="currentColor"
              />
            </svg>
            You are the host of this event. For any further actions related to
            this event, please switch to the Host role from the Account tab.
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="event-detailed-wedding-event-manager">
      {renderTabs()}

      {activeTab === "about" && (
        <div className="event-detailed-detailed-event-about">
          {renderEventHeader()}
          {renderEventImage()}
          {renderEventDescription()}
        </div>
      )}

      {activeTab === "guest" && (
        <>
          {isHost && isMobile && (
            <div className="event-detailed-tab-selector-mobile-search">
              <input
                type="text"
                className="event-detailed-tab-selector-mobile-search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearch}
              />

              <span className="usher-list-search-icon" style={{ top: "30%" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </span>
            </div>
          )}

          <GuestListItem
            guests={filteredGuests}
            refunds={refunds}
            event={event}
            userRole={userRole}
            onRefresh={onRefresh}
            searchTerm={searchTerm}
            invitation={event?.invitations}
          />
        </>
      )}

      {activeTab === "usher" && (
        <UsherList ushers={ushers} eventId={event._id} />
      )}

      {activeTab === "refund" && isHost && (
        <>
          {isMobile && (
            <div className="event-detailed-tab-selector-mobile-search">
              <input
                type="text"
                className="event-detailed-tab-selector-mobile-search-input"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearch}
              />

              <span className="usher-list-search-icon" style={{ top: "30%" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </span>
            </div>
          )}
          <RefundList
            refunds={refunds}
            searchTerm={searchTerm}
            onApprove={({ eventId, refundId }) =>
              handleRefundAction({ eventId, refundId, action: "accepted" })
            }
            onDecline={({ eventId, refundId }) =>
              handleRefundAction({ eventId, refundId, action: "declined" })
            }
            role={userRole}
          />
        </>
      )}

      {activeTab === "others" && isGuest && (
        <OtherPurchaseOptions
          event={event}
          onPurchaseClick={handlePurchaseClick}
          invitation={invitation}
        />
      )}

      {mandatoryPurchaseData && (
        <MandatoryPurchaseModal
          isOpen={true}
          type={mandatoryPurchaseData.type}
          options={mandatoryPurchaseData.options}
          onClose={() => setMandatoryPurchaseData(null)}
          event={event}
          onProceed={handleMandatoryPurchaseProceed}
          onPayLater={handleMandatoryPurchasePayLater}
        />
      )}

      {isGuest && (
        <>
          <PurchaseOptionsModal
            isOpen={isPurchaseModalOpen}
            onClose={() => {
              setIsPurchaseModalOpen(false);
              refreshEventDetails();
            }}
            onProceed={() => {
              setIsPurchaseModalOpen(false);
              refreshEventDetails();
            }}
            event={event}
            onPurchaseClick={(type, options) => {
              setOpenMandatoryModal({ type, options });
            }}
          />

          <MandatoryPurchaseModal
            isOpen={isMandatoryPurchaseModalOpen}
            onClose={closeModal}
            onProceed={handleMandatoryPurchaseProceed}
            onPayLater={handleMandatoryPurchasePayLater}
            event={eventId}
            type={purchaseType}
            options={purchaseOptions}
          />

          <AcceptModal
            isOpen={isAcceptModalOpen}
            onClose={() => !isProceeding && setIsAcceptModalOpen(false)}
            onProceed={handleAcceptProceed}
          />
        </>
      )}

      <DeclineModal
        isOpen={isDeclineModalOpen}
        onClose={() => !isProceeding && setIsDeclineModalOpen(false)}
        onProceed={handleDeclineProceed}
      />

      {scannerVisible && (
        <QRScanner
          isOpen={scannerVisible}
          onClose={() => setScannerVisible(false)}
          onScanSuccess={handleScanSuccess}
          eventId={event?._id}
        />
      )}

      {confirmationModalVisible && scannedGuestData && (
        <CheckInConfirmationModal
          isOpen={confirmationModalVisible}
          onClose={() => {
            setConfirmationModalVisible(false);
            setScannedGuestData(null);
          }}
          onConfirm={handleConfirmCheckIn}
          guestData={scannedGuestData}
          isLoading={isCheckingIn}
        />
      )}

      {showDigitalTicket && (
        <DigitalTicket
          isOpen={showDigitalTicket}
          onClose={() => setShowDigitalTicket(false)}
          ticketData={{
            guestName: user?.firstName + " " + user?.lastName || "Guest",
            guestId: user?._id,
            eventId: event?._id,
            eventTitle: event?.eventTitle || "Untitled Event",
            eventDate: event?.eventDate || event?.startDate,
            eventTime: event?.eventTime || event?.startTime,
            eventLocation:
              event?.eventLocation || event?.customAddress || "Venue TBD",
            ticketType:
              invitation?.ticketFeePaid?.find((t) => t.paid)?.ticketType ||
              "Standard",
            isCheckedIn: invitation?.checkInStatus === "checked-in",
            invitationStatus: invitation?.status,
          }}
          event={event}
        />
      )}

      <InviteTypeSelectorModal
        visible={inviteSelectorVisible}
        onClose={() => setInviteSelectorVisible(false)}
        onSelect={(role) => {
          setInviteRole(role);
          setShareModalVisible(true);
        }}
      />

      <ShareLinkModal
        visible={shareModalVisible}
        onClose={() => setShareModalVisible(false)}
        eventData={event}
        inviteRole={inviteRole}
      />

      <EventStatusModal
        isOpen={eventStatusModalVisible}
        onClose={() => setEventStatusModalVisible(false)}
        status={eventStatusModalType}
        onEdit={handleEditEvent}
      />

      <RoleSwitchConfirmationModal
        visible={showRoleSwitchModal}
        onClose={() => {
          setShowRoleSwitchModal(false);
          setOriginalRoleBeforeSwitch(null);
        }}
        currentRole={originalRoleBeforeSwitch || userRole || "host"}
        targetRole="guest"
        onConfirm={handleRoleSwitchConfirm}
        isLoading={isRoleSwitching}
      />

      <ContactInfoModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        onSubmit={handleContactSubmit}
        eventTitle={event?.eventTitle}
        loading={isSubmittingInterest}
        onLoginRedirect={handleLoginFromContactModal}
      />

      <InterestedSuccessModal
        isOpen={isSuccessModalOpen}
        onClose={handleSuccessModalClose}
        title={successMessage.title}
        message={successMessage.message}
      />
    </div>
  );
};

export default DetailedEvent;
